/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { HintContainer, HintTextBlock, HintText } from './styles'

const GenresHint = () => {
  const { t } = useTranslation()

  return (
    <HintContainer>
      <HintTextBlock>
        <HintText>{t('scheduleCampaignPage.basedOnGenresYouSelect')}</HintText>
      </HintTextBlock>
    </HintContainer>
  )
}
export default GenresHint
